<div *ngIf="loaded">
  <div class="header">
    <svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
      <path d="M19 9h-4V3H9v6H5l7 7 7-7zM5 18v2h14v-2H5z" />
    </svg>
    <span class="title" [innerHtml]="navigation.captionDownloads | safeHTML"></span>
  </div>

  <div class="download-wrapper" *ngFor="let download of navigation.downloads" (click)="onDownload(download)">
    <container-element [ngSwitch]="download.contentType">
      <ng-container *ngSwitchCase="DOWNLOAD_TYPE.IMAGE" class="icon-wrapper">
        <img [src]="download.link" />
      </ng-container>

      <ng-container *ngSwitchCase="DOWNLOAD_TYPE.PDF">
        <div class="icon-wrapper">
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
              d="M18.75 3H5.25A2.257 2.257 0 0 0 3 5.25v13.5A2.257 2.257 0 0 0 5.25 21h13.5A2.257 2.257 0 0 0 21 18.75V5.25A2.257 2.257 0 0 0 18.75 3zm-9.563 8.438c0 .933-.753 1.687-1.687 1.687H6.375v2.25H4.687v-6.75H7.5c.934 0 1.688.754 1.688 1.688v1.124zm5.626 2.25c0 .933-.754 1.687-1.688 1.687h-2.813v-6.75h2.813c.934 0 1.688.754 1.688 1.688v3.374zm4.5-3.376h-1.688v1.126h1.688v1.687h-1.688v2.25h-1.688v-6.75h3.376v1.688zM6.374 11.438H7.5v-1.126H6.375v1.126zM12 13.688h1.125v-3.376H12v3.376z"
              fill="#577399"
            />
          </svg>
        </div>
      </ng-container>

      <ng-container *ngSwitchCase="DOWNLOAD_TYPE.WORD" class="icon-wrapper">
        <div class="icon-wrapper">
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M5.25 3h13.5A2.257 2.257 0 0 1 21 5.25v13.5A2.257 2.257 0 0 1 18.75 21H5.25A2.257 2.257 0 0 1 3 18.75V5.25A2.257 2.257 0 0 1 5.25 3zm6.667 12.108c-.84 0-1.461-.285-1.863-.855-.396-.57-.594-1.368-.594-2.394s.198-1.824.594-2.394c.402-.57 1.023-.855 1.863-.855.84 0 1.458.285 1.854.855.402.57.603 1.368.603 2.394s-.201 1.824-.603 2.394c-.396.57-1.014.855-1.854.855zm0-1.09c.384 0 .648-.14.792-.422.15-.288.225-.687.225-1.197v-1.09c0-.503-.075-.896-.225-1.178-.144-.288-.408-.432-.792-.432-.384 0-.651.144-.801.432-.144.282-.216.675-.216 1.179v1.098c0 .504.072.9.216 1.188.15.282.417.423.8.423zm-7.34-5.3H6.6c.846 0 1.473.27 1.881.81.408.54.612 1.317.612 2.33 0 1.015-.204 1.792-.612 2.332-.408.54-1.035.81-1.88.81H4.575V8.718zm1.934 5.22c.402 0 .696-.13.882-.387.186-.258.28-.633.28-1.125v-1.143c0-.486-.094-.858-.28-1.116-.186-.258-.48-.387-.882-.387h-.603v4.158h.603zm8.894.324c.408.564 1.032.846 1.872.846.324 0 .61-.042.855-.126.252-.084.468-.204.648-.36a1.99 1.99 0 0 0 .441-.576 3.06 3.06 0 0 0 .28-.747l-1.26-.306c-.067.3-.172.546-.316.738-.138.192-.363.288-.675.288-.366 0-.627-.141-.783-.423-.15-.288-.225-.684-.225-1.188V11.31c0-.504.075-.897.225-1.18.156-.287.417-.431.783-.431.156 0 .288.027.396.08a.695.695 0 0 1 .28.208c.077.09.14.198.188.324.048.126.09.264.126.414l1.26-.306a3.061 3.061 0 0 0-.279-.747 1.874 1.874 0 0 0-.44-.567 1.888 1.888 0 0 0-.649-.36 2.483 2.483 0 0 0-.855-.135c-.84 0-1.464.285-1.872.855-.402.564-.603 1.362-.603 2.394s.201 1.833.603 2.403z"
              fill="#577399"
            />
          </svg>
        </div>
      </ng-container>

      <ng-container *ngSwitchCase="DOWNLOAD_TYPE.MUSIC" class="icon-wrapper">
        <div class="icon-wrapper">
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M12 3v10.55c-.59-.34-1.27-.55-2-.55-2.21 0-4 1.79-4 4s1.79 4 4 4 4-1.79 4-4V7h4V3h-6z" fill="#577399" />
          </svg>
        </div>
      </ng-container>

      <ng-container *ngSwitchCase="DOWNLOAD_TYPE.EXCEL" class="icon-wrapper">
        <div class="icon-wrapper">
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M5.25 3h13.5A2.257 2.257 0 0 1 21 5.25v13.5A2.257 2.257 0 0 1 18.75 21H5.25A2.257 2.257 0 0 1 3 18.75V5.25A2.257 2.257 0 0 1 5.25 3zm10.433 14H13.46l-.936-1.807-.637-1.43h-.117l-.65 1.43-.163.307H12V17H8.117l2.548-4.693-2.379-4.381h2.223l.741 1.443.663 1.456h.104l.676-1.456.78-1.443h2.041l-2.379 4.407L15.683 17z"
              fill="#577399"
            />
          </svg>
        </div>
      </ng-container>

      <ng-container *ngSwitchCase="DOWNLOAD_TYPE.VIDEO" class="icon-wrapper">
        <div class="icon-wrapper">
          <svg width="23" height="23" viewBox="0 0 23 23" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
              d="M13.416 4.79183C13.416 3.73766 12.5535 2.87516 11.4993 2.87516H10.541V1.91683C10.541 1.38975 10.1098 0.958496 9.58268 0.958496H5.74935C5.22227 0.958496 4.79102 1.38975 4.79102 1.91683V2.87516H3.83268C2.77852 2.87516 1.91602 3.73766 1.91602 4.79183V19.1668C1.91602 20.221 2.77852 21.0835 3.83268 21.0835H11.4993C12.5535 21.0835 13.416 20.221 13.416 19.1668H21.0827V4.79183H13.416ZM11.4993 17.2502H9.58268V15.3335H11.4993V17.2502ZM11.4993 8.62516H9.58268V6.7085H11.4993V8.62516ZM15.3327 17.2502H13.416V15.3335H15.3327V17.2502ZM15.3327 8.62516H13.416V6.7085H15.3327V8.62516ZM19.166 17.2502H17.2493V15.3335H19.166V17.2502ZM19.166 8.62516H17.2493V6.7085H19.166V8.62516Z"
              fill="#577399"
            />
          </svg>
        </div>
      </ng-container>

      <ng-container *ngSwitchCase="DOWNLOAD_TYPE.LINK" class="icon-wrapper">
        <div class="icon-wrapper">
          <svg width="23" height="23" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
              d="M18.208 18.208H4.792V4.792H11.5V2.875H4.792a1.916 1.916 0 0 0-1.917 1.917v13.416c0 1.055.853 1.917 1.917 1.917h13.416a1.922 1.922 0 0 0 1.917-1.917V11.5h-1.917v6.708zM13.417 2.875v1.917h3.44l-9.42 9.42 1.35 1.351 9.421-9.42v3.44h1.917V2.875h-6.708z"
              fill="#577399"
            />
          </svg>
        </div>
      </ng-container>

      <ng-container *ngSwitchDefault class="icon-wrapper">
        <div class="icon-wrapper">
          <svg width="23" height="23" viewBox="0 0 23 23" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
              d="M5.75065 1.9165C4.69648 1.9165 3.84357 2.779 3.84357 3.83317L3.83398 19.1665C3.83398 20.2207 4.6869 21.0832 5.74107 21.0832H17.2506C18.3048 21.0832 19.1673 20.2207 19.1673 19.1665V7.6665L13.4173 1.9165H5.75065ZM12.459 8.62484V3.354L17.7298 8.62484H12.459Z"
              fill="#577399"
            />
          </svg>
        </div>
      </ng-container>
    </container-element>

    <div class="text-wrapper">
      <span class="headline">{{ download.name }}</span>
      <span class="underline">{{ download.size ? Math.round(download.size / 1000) + ' KB' : '-' }}</span>
    </div>
    
    <svg *ngIf="download.contentType !== DOWNLOAD_TYPE.LINK" style="min-width: 24px;" width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
      <path d="M19 9h-4V3H9v6H5l7 7 7-7zM5 18v2h14v-2H5z" fill="#484b53" />
    </svg>
    <svg *ngIf="download.contentType === DOWNLOAD_TYPE.LINK" style="min-width: 24px;" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M19 19H5V5h7V3H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14c1.1 0 2-.9 2-2v-7h-2v7zM14 3v2h3.59l-9.83 9.83 1.41 1.41L19 6.41V10h2V3h-7z" fill="#484b53"/>
  </svg>
  </div>

  <div class="mobile-download" *ngIf="downloadSelected">
    <mat-toolbar>
      <svg (click)="close()" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M19.6 11H7.43l5.59-5.59L11.6 4l-8 8 8 8 1.41-1.41L7.43 13H19.6v-2z" />
      </svg>
      <span class="heading">{{ selectedDownload.name }}</span>
    </mat-toolbar>

    <div class="mobile-wrapper">
      <img
        *ngIf="
          selectedDownload.link.split('.').pop() === 'png' ||
          selectedDownload.link.split('.').pop() === 'jpg' ||
          selectedDownload.link.split('.').pop() === 'jpeg'
        "
        [src]="selectedDownload.link"
      />

      <div
        class="icon-wrapper center"
        *ngIf="
          !(
            selectedDownload.link.split('.').pop() === 'png' ||
            selectedDownload.link.split('.').pop() === 'jpg' ||
            selectedDownload.link.split('.').pop() === 'jpeg'
          )
        "
      >
        <!-- PDF -->
        <svg
          *ngIf="selectedDownload.link.split('.').pop() === 'pdf'"
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M18.75 3H5.25A2.257 2.257 0 0 0 3 5.25v13.5A2.257 2.257 0 0 0 5.25 21h13.5A2.257 2.257 0 0 0 21 18.75V5.25A2.257 2.257 0 0 0 18.75 3zm-9.563 8.438c0 .933-.753 1.687-1.687 1.687H6.375v2.25H4.687v-6.75H7.5c.934 0 1.688.754 1.688 1.688v1.124zm5.626 2.25c0 .933-.754 1.687-1.688 1.687h-2.813v-6.75h2.813c.934 0 1.688.754 1.688 1.688v3.374zm4.5-3.376h-1.688v1.126h1.688v1.687h-1.688v2.25h-1.688v-6.75h3.376v1.688zM6.374 11.438H7.5v-1.126H6.375v1.126zM12 13.688h1.125v-3.376H12v3.376z"
            fill="#577399"
          />
        </svg>
        <!-- DOC -->
        <svg
          *ngIf="selectedDownload.link.split('.').pop().startsWith('doc')"
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M5.25 3h13.5A2.257 2.257 0 0 1 21 5.25v13.5A2.257 2.257 0 0 1 18.75 21H5.25A2.257 2.257 0 0 1 3 18.75V5.25A2.257 2.257 0 0 1 5.25 3zm6.667 12.108c-.84 0-1.461-.285-1.863-.855-.396-.57-.594-1.368-.594-2.394s.198-1.824.594-2.394c.402-.57 1.023-.855 1.863-.855.84 0 1.458.285 1.854.855.402.57.603 1.368.603 2.394s-.201 1.824-.603 2.394c-.396.57-1.014.855-1.854.855zm0-1.09c.384 0 .648-.14.792-.422.15-.288.225-.687.225-1.197v-1.09c0-.503-.075-.896-.225-1.178-.144-.288-.408-.432-.792-.432-.384 0-.651.144-.801.432-.144.282-.216.675-.216 1.179v1.098c0 .504.072.9.216 1.188.15.282.417.423.8.423zm-7.34-5.3H6.6c.846 0 1.473.27 1.881.81.408.54.612 1.317.612 2.33 0 1.015-.204 1.792-.612 2.332-.408.54-1.035.81-1.88.81H4.575V8.718zm1.934 5.22c.402 0 .696-.13.882-.387.186-.258.28-.633.28-1.125v-1.143c0-.486-.094-.858-.28-1.116-.186-.258-.48-.387-.882-.387h-.603v4.158h.603zm8.894.324c.408.564 1.032.846 1.872.846.324 0 .61-.042.855-.126.252-.084.468-.204.648-.36a1.99 1.99 0 0 0 .441-.576 3.06 3.06 0 0 0 .28-.747l-1.26-.306c-.067.3-.172.546-.316.738-.138.192-.363.288-.675.288-.366 0-.627-.141-.783-.423-.15-.288-.225-.684-.225-1.188V11.31c0-.504.075-.897.225-1.18.156-.287.417-.431.783-.431.156 0 .288.027.396.08a.695.695 0 0 1 .28.208c.077.09.14.198.188.324.048.126.09.264.126.414l1.26-.306a3.061 3.061 0 0 0-.279-.747 1.874 1.874 0 0 0-.44-.567 1.888 1.888 0 0 0-.649-.36 2.483 2.483 0 0 0-.855-.135c-.84 0-1.464.285-1.872.855-.402.564-.603 1.362-.603 2.394s.201 1.833.603 2.403z"
            fill="#577399"
          />
        </svg>
        <!-- Music -->
        <svg
          *ngIf="selectedDownload.link.split('.').pop().startsWith('mp3') || selectedDownload.link.split('.').pop().startsWith('wav')"
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path d="M12 3v10.55c-.59-.34-1.27-.55-2-.55-2.21 0-4 1.79-4 4s1.79 4 4 4 4-1.79 4-4V7h4V3h-6z" fill="#577399" />
        </svg>
        <!-- Excel -->
        <svg
          *ngIf="selectedDownload.link.split('.').pop().startsWith('xl') || selectedDownload.link.split('.').pop().startsWith('csv')"
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M5.25 3h13.5A2.257 2.257 0 0 1 21 5.25v13.5A2.257 2.257 0 0 1 18.75 21H5.25A2.257 2.257 0 0 1 3 18.75V5.25A2.257 2.257 0 0 1 5.25 3zm10.433 14H13.46l-.936-1.807-.637-1.43h-.117l-.65 1.43-.163.307H12V17H8.117l2.548-4.693-2.379-4.381h2.223l.741 1.443.663 1.456h.104l.676-1.456.78-1.443h2.041l-2.379 4.407L15.683 17z"
            fill="#577399"
          />
        </svg>
        <!-- Video -->
        <svg
          *ngIf="selectedDownload.link.split('.').pop().startsWith('mp4') || selectedDownload.link.split('.').pop().startsWith('mov')"
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M26.416 17.7918C26.416 16.7377 25.5535 15.8752 24.4993 15.8752H23.541V14.9168C23.541 14.3897 23.1098 13.9585 22.5827 13.9585H18.7493C18.2223 13.9585 17.791 14.3897 17.791 14.9168V15.8752H16.8327C15.7785 15.8752 14.916 16.7377 14.916 17.7918V32.1668C14.916 33.221 15.7785 34.0835 16.8327 34.0835H24.4993C25.5535 34.0835 26.416 33.221 26.416 32.1668H34.0827V17.7918H26.416ZM24.4993 30.2502H22.5827V28.3335H24.4993V30.2502ZM24.4993 21.6252H22.5827V19.7085H24.4993V21.6252ZM28.3327 30.2502H26.416V28.3335H28.3327V30.2502ZM28.3327 21.6252H26.416V19.7085H28.3327V21.6252ZM32.166 30.2502H30.2493V28.3335H32.166V30.2502ZM32.166 21.6252H30.2493V19.7085H32.166V21.6252Z"
            fill="#577399"
          />
        </svg>

        <!-- Link -->
        <svg
          *ngIf="!selectedDownload.link.includes('amazonaws.com')"
          width="23"
          height="23"
          viewBox="0 0 23 23"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M18.208 18.208H4.792V4.792H11.5V2.875H4.792a1.916 1.916 0 0 0-1.917 1.917v13.416c0 1.055.853 1.917 1.917 1.917h13.416a1.922 1.922 0 0 0 1.917-1.917V11.5h-1.917v6.708zM13.417 2.875v1.917h3.44l-9.42 9.42 1.35 1.351 9.421-9.42v3.44h1.917V2.875h-6.708z"
            fill="#577399"
          />
        </svg>
      </div>
      <span
        class="name"
        *ngIf="
          !(
            selectedDownload.link.split('.').pop() === 'png' ||
            selectedDownload.link.split('.').pop() === 'jpg' ||
            selectedDownload.link.split('.').pop() === 'jpeg'
          )
        "
        >{{ selectedDownload.name }}</span
      >
      <button (click)="onMobileDowload()" class="downloadButton" mat-flat-button *ngIf="selectedDownload.link.includes('amazonaws.com')">
        <svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
          <path d="M19 9h-4V3H9v6H5l7 7 7-7zM5 18v2h14v-2H5z" />
        </svg>
        Download
      </button>
      <button (click)="onMobileDowload()" class="downloadButton" mat-flat-button *ngIf="!selectedDownload.link.includes('amazonaws.com')">
        <svg width="23" height="23" viewBox="0 0 23 23" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path
            d="M18.208 18.208H4.792V4.792H11.5V2.875H4.792a1.916 1.916 0 0 0-1.917 1.917v13.416c0 1.055.853 1.917 1.917 1.917h13.416a1.922 1.922 0 0 0 1.917-1.917V11.5h-1.917v6.708zM13.417 2.875v1.917h3.44l-9.42 9.42 1.35 1.351 9.421-9.42v3.44h1.917V2.875h-6.708z"
          />
        </svg>
        Website
      </button>
    </div>
  </div>
</div>
